<div class="eo-main">
  <header class="eo-header">
    <h1 class="eo-title">{{ 'Spend Intelligence' | translate }}</h1>
    <p class="eo-subtitle">{{ 'AI-driven insights and recommendations.' | translate }}</p>
  </header>


  <section class="eo-kpi-row eo-kpi-row--intelligence">
    <article class="eo-card eo-card--kpi" (click)="onKpiClick('totalCategory')" style="cursor:pointer;">
      <div class="eo-card-body">
        <div class="eo-card-label">{{ 'Total Category Spend' | translate }}</div>
        <div class="eo-card-value">
          <ng-container *ngIf="loadingTotalCategorySpend; else totalValue">
            <mat-spinner diameter="30" color="accent"></mat-spinner>
          </ng-container>
          <ng-template #totalValue>{{ totalCategorySpend | abbreviatedNumber }}</ng-template>
        </div>
        <div class="eo-card-sub">{{ 'Compared to previous quarter' | translate }}</div>
      </div>
    </article>
    <article class="eo-card eo-card--kpi" (click)="onKpiClick('avgPriceVariance')" style="cursor:pointer;">
      <div class="eo-card-body">
        <div class="eo-card-label">{{ 'Avg. Price Variance' | translate }}</div>
        <div class="eo-card-value">2.8%</div>
        <div class="eo-card-sub">{{ 'Across key items' | translate }}</div>
      </div>
    </article>
    <article class="eo-card eo-card--kpi" (click)="onKpiClick('tailSpend')" style="cursor:pointer;">
      <div class="eo-card-body">
        <div class="eo-card-label">{{ 'Identified Tail Spend' | translate }}</div>
        <div class="eo-card-value">
          <ng-container *ngIf="loadingTailSpend; else tailValue">
            <mat-spinner diameter="30" color="accent"></mat-spinner>
          </ng-container>
          <ng-template #tailValue>{{ tailSpendTotal | abbreviatedNumber }}</ng-template>
        </div>
        <div class="eo-card-sub">{{ 'Opportunities for consolidation' | translate }}</div>
      </div>
    </article>
  </section>

  <section class="eo-row eo-row--charts">
    <article class="eo-panel eo-panel--chart">
      <header class="eo-panel-header">
        <h3 class="eo-panel-title">{{ 'Category Spend Breakdown' | translate }}</h3>
      </header>
      <div class="eo-panel-body">
        <div class="eo-donut-chart" style="height:260px;display:flex;align-items:center;justify-content:center;">
          <ng-container *ngIf="loadingLevel1; else donutChart">
            <mat-spinner diameter="50" color="accent"></mat-spinner>
          </ng-container>
          <ng-template #donutChart>
            <canvas baseChart [data]="categoryDonutData" [options]="categoryDonutOptions" [type]="'doughnut'" (chartClick)="onCategoryDonutClick($event)"></canvas>
          </ng-template>
        </div>
        <div style="display:flex;justify-content:center;gap:12px;margin-top:16px;">
          <div style="display:flex;gap:16px;align-items:center;flex-wrap:wrap;">
            <ng-container *ngFor="let item of legendItems; let i = index">
              <div (click)="selectLegend(i)"
                style="display:flex;align-items:center;gap:8px;cursor:pointer;padding:4px;border-radius:4px;">
                <div [style.background]="item.color" [style.width.px]="14" [style.height.px]="14"
                  style="border-radius:50%"
                  [style.border]="selectedLegend===item.label ? '2px solid var(--sk-color-brand)' : '2px solid transparent'"></div>
                <div *ngIf="selectedLegend===item.label" style="font-size:14px;color:var(--sk-color-text-primary);font-weight:600">{{ item.label
                  }}</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </article>

    <article class="eo-panel eo-panel--chart">
      <header class="eo-panel-header">
        <h3 class="eo-panel-title">{{ 'Top 5 Categories' | translate }}</h3>
      </header>
      <div class="eo-panel-body" style="height:260px;display:flex;flex-direction:column;">
        <div style="flex:1;display:flex;align-items:stretch;">
          <div style="flex:1;">
            <ng-container *ngIf="loadingTopLevel4; else topBarChart">
              <mat-spinner diameter="50" color="accent"></mat-spinner>
            </ng-container>
            <ng-template #topBarChart>
                <canvas baseChart [data]="topCategoriesBarData" [options]="topCategoriesBarOptions" [type]="'bar'"
                [plugins]="[topBubblePlugin]" (chartClick)="onTopCategoriesClick($event)"></canvas>
            </ng-template>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:center;gap:12px;margin:1rem;">
        <div style="display:flex;gap:16px;align-items:center;flex-wrap:wrap;">
            <ng-container *ngFor="let item of topLegendItems; let i = index">
            <div (click)="onTopLegendClick(item.label)"
              style="display:flex;align-items:center;gap:8px;cursor:pointer;padding:4px;border-radius:4px;">
              <div [style.background]="item.color" [style.width.px]="14" [style.height.px]="14"
                style="border-radius:50%"
                [style.border]="selectedTopLegend===item.label ? '2px solid var(--sk-color-brand)' : '2px solid transparent'"></div>
              <div *ngIf="selectedTopLegend===item.label" style="font-size:14px;color:var(--sk-color-text-primary);font-weight:600">{{
                item.label }}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </article>
  </section>

  <section class="eo-row eo-row--tables">
    <article class="eo-panel">
      <header class="eo-panel-header">
        <h3 class="eo-panel-title">{{ 'Yearly Spend Category' | translate }}</h3>
      </header>
      <div class="eo-panel-body" style="height:260px;display:flex;align-items:center;justify-content:center;">
        <ng-container *ngIf="loadingYearly; else yearlyChart">
          <mat-spinner diameter="50" color="accent"></mat-spinner>
        </ng-container>
        <ng-template #yearlyChart>
          <canvas baseChart [data]="yearlyBarData" [options]="yearlyBarOptions" [type]="'bar'" (chartClick)="onYearlyBarClick($event)"></canvas>
        </ng-template>
      </div>
    </article>

    <article class="eo-panel">
      <header class="eo-panel-header">
        <h3 class="eo-panel-title">{{ 'Spend Recommendations' | translate }}</h3>
      </header>
      <div class="eo-panel-body" style="min-height:120px;display:flex;align-items:center;justify-content:center;">
        <ng-container *ngIf="loadingRecommendations; else recommendationsTable">
          <app-sk-table-loader [visible]="true" variant="arcs" label="Loading"></app-sk-table-loader>
        </ng-container>
        <ng-template #recommendationsTable>
          <table class="eo-table" style="width:100%;border-collapse:collapse;">
            <thead>
              <tr class="eo-table-header">
                <th style="text-align:left;padding:8px 12px">{{ 'Category' | translate }}</th>
                <th style="text-align:right;padding:8px 12px">{{ 'Savings Low' | translate }}</th>
                <th style="text-align:right;padding:8px 12px">{{ 'Savings High' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of spendRecommendations" class="eo-table-row" [class.eo-row-selected]="selectedRecommendation === r.category || isRecommendationMultiSelected(r.category)" (click)="onRecommendationClick(r, $event)" style="cursor:pointer;">
                <td style="padding:8px 12px">{{ r.category }}</td>
                <td style="padding:8px 12px;text-align:right">{{ r.savings_low | currency:'USD':'symbol':'1.0-0' }}</td>
                <td style="padding:8px 12px;text-align:right">{{ r.savings_high | currency:'USD':'symbol':'1.0-0' }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </article>
  </section>

  <!-- Tail Spend Identification: three panels side-by-side -->
  <section class="eo-row eo-row--tail" style="grid-template-columns:repeat(1, 1fr); gap:16px;">
    <article class="eo-panel">
      <header class="eo-panel-header">
        <h3 class="eo-panel-title">{{ 'Tail Spend Identification' | translate }}</h3>
      </header>
      <div class="eo-panel-body" style="display:flex;gap:12px;padding:20px;">
        <div style="flex:1;">
          <div class="eo-panel"
            style="height:350px;display:flex;flex-direction:column;justify-content:center;align-items:center;">
            <div style="width:90%;height:140px;">
              <div style="font-weight:600;color:var(--sk-color-text-primary);margin-bottom:6px;">{{ 'Spend Distribution by Category' | translate }}</div>
              <canvas baseChart [data]="smallDistributionBarData" [options]="smallDistributionBarOptions"
                [type]="'bar'" (chartClick)="onDistributionBarClick($event)" style="cursor:pointer;"></canvas>
            </div>
            <div
              style="width:90%;height:80px;margin-top:4rem;display:flex;flex-direction:column;justify-content:center;align-items:center;">
              <div style="font-weight:600;color:var(--sk-color-text-primary);margin-bottom:6px;">{{ 'Transaction Count Split' | translate }}</div>
              <canvas baseChart [data]="smallTransactionDonutData" [options]="smallTransactionDonutOptions"
                [type]="'doughnut'" style="width:90px;height:90px;" (chartClick)="onSmallTransactionDonutClick($event)"></canvas>
            </div>
          </div>
        </div>

        <div style="flex:1;">
          <div class="eo-panel" style="height:350px;display:flex;flex-direction:column;">
            <div style="padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;">
              <div style="flex:1;">
                <div style="font-weight:700;font-size:22px;">{{ 'Head of Tail' | translate }}</div>
                <div style="color:var(--sk-color-text-muted);margin-top:6px;font-size:14px;margin-right:12px;">
                  <ng-container *ngIf="loadingHeadOfTail; else headValue">
                    <mat-spinner diameter="30" color="accent"></mat-spinner>
                  </ng-container>
                  <ng-template #headValue>{{ headOfTailTotal | abbreviatedNumber }} {{ 'Spent' | translate }}</ng-template>
                </div>
              </div>
              <div style="width:120px;height:120px;flex:0 0 120px;">
                <canvas baseChart [data]="headOfTailDonutData" [options]="headOfTailDonutOptions" [type]="'doughnut'"
                  [plugins]="[headOfTailDonutPlugin]" (chartClick)="onHeadOfTailClick($event)"></canvas>
              </div>
            </div>
            <div style="flex:1;overflow:auto;border-top:1px solid var(--sk-color-bg-panel);padding:8px 16px;">
                  <div class="eo-table">
                    <ng-container *ngIf="loadingHeadOfTail">
                      <div style="display:flex;align-items:center;justify-content:center;padding:16px;"><mat-spinner
                          diameter="28" color="accent"></mat-spinner></div>
                    </ng-container>
                    <ng-container *ngIf="!loadingHeadOfTail">
                      <div *ngFor="let s of headOfTailTopSuppliers; let i = index"
                        [ngClass]="{'eo-table-row--alt': i % 2 === 0, 'eo-table-row--selected': selectedHeadOfTailSupplier===s.name}" class="eo-table-row" (click)="onHeadOfTailSupplierClick(s.name, $event)" style="cursor:pointer;">
                        <div>{{ s.name }}</div>
                        <div class="eo-td--spend">{{ s.amount | abbreviatedNumber }}</div>
                      </div>
                      <div *ngIf="!headOfTailTopSuppliers || headOfTailTopSuppliers.length === 0"
                        style="padding:12px;color:var(--sk-color-text-muted);">{{ 'No supplier data available' | translate }}</div>
                    </ng-container>
                  </div>
            </div>
          </div>
        </div>

        <div style="flex:1;">
          <div class="eo-panel" style="height:350px;display:flex;flex-direction:column;">
            <div style="padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;">
              <div style="flex:1;">
                <div style="font-weight:700;font-size:22px;">{{ 'Tail of Tail' | translate }}</div>
                <div style="color:var(--sk-color-text-muted);margin-top:6px;font-size:14px;margin-right:12px;">
                  <ng-container *ngIf="loadingTailOfTail; else tailOfTailValue">
                    <mat-spinner diameter="30" color="accent"></mat-spinner>
                  </ng-container>
                  <ng-template #tailOfTailValue>{{ tailOfTailTotal | abbreviatedNumber }} {{ 'Spent' | translate }}</ng-template>
                </div>
              </div>
              <div style="width:120px;height:120px;flex:0 0 120px;">
                <canvas baseChart [data]="tailOfTailDonutData" [options]="tailOfTailDonutOptions" [type]="'doughnut'"
                  [plugins]="[tailOfTailDonutPlugin]" (chartClick)="onTailOfTailClick($event)"></canvas>
              </div>
            </div>
            <div style="flex:1;overflow:auto;border-top:1px solid var(--sk-color-bg-panel);padding:8px 16px;">
              <div class="eo-table">
                <ng-container *ngIf="loadingTailOfTail">
                  <div style="display:flex;align-items:center;justify-content:center;padding:16px;"><mat-spinner
                      diameter="28" color="accent"></mat-spinner></div>
                </ng-container>
                <ng-container *ngIf="!loadingTailOfTail">
                  <div *ngFor="let s of tailOfTailTopSuppliers; let i = index"
                    [ngClass]="{'eo-table-row--alt': i % 2 === 0, 'eo-table-row--selected': selectedTailOfTailSupplier===s.name}" class="eo-table-row" (click)="onTailOfTailSupplierClick(s.name, $event)" style="cursor:pointer;">
                    <div>{{ s.name }}</div>
                    <div class="eo-td--spend">{{ s.amount | abbreviatedNumber }}</div>
                  </div>
                  <div *ngIf="!tailOfTailTopSuppliers || tailOfTailTopSuppliers.length === 0"
                    style="padding:12px;color:var(--sk-color-text-muted);">{{ 'No supplier data available' | translate }}</div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>

  <!-- Next Steps & Actions -->
  <section class="eo-panel" style="margin-top:24px;">
    <header class="eo-panel-header">
      <h3 class="eo-panel-title">{{ 'Next Steps &amp; Actions' | translate }}</h3>
    </header>
    <div class="eo-panel-body">
      <p style="color:var(--sk-color-text-muted);">{{ 'Based on the current category intelligence, consider the following actions to optimize spend and improve supplier relationships.' | translate }}</p>
      <div style="margin-top:16px;display:flex;gap:12px;flex-wrap:wrap;">
        <button
          style="background:var(--sk-color-brand);color:var(--sk-color-white);border:none;padding:10px 18px;border-radius:6px;cursor:pointer;">{{ 'Initiate Negotiation' | translate }}</button>
        <button
          style="background:var(--sk-color-white);border:1px solid var(--sk-color-border);padding:10px 18px;border-radius:6px;cursor:pointer;">{{ 'Consolidate Suppliers' | translate }}</button>
        <button
          style="background:var(--sk-color-white);border:1px solid var(--sk-color-border);padding:10px 18px;border-radius:6px;cursor:pointer;">{{ 'Review Contract Terms' | translate }}</button>
        <button
          style="background:var(--sk-color-white);border:1px solid var(--sk-color-border);padding:10px 18px;border-radius:6px;cursor:pointer;">{{ 'Generate Detailed Report' | translate }}</button>
      </div>
    </div>
  </section>
</div>